// import { useState }           from 'react';

function useFooter(props) {
    const { refs } = props;

    function handleScrollTo(name) {
        return () => {
            refs[name].current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }

    return {
        handleScrollTo
    };
}

export default useFooter;
